import React from 'react';
import { createSelector } from 'reselect';
import { styled } from '@compiled/react';
import {
	SERVICE_DESK_PROJECT,
	CORE_PROJECT,
	SOFTWARE_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types.tsx';
import { FormattedMessage } from '@atlassian/jira-intl';
import type { ProjectTypeSelectOption } from '../model/types.tsx';
import {
	getProjectTypes as getStateProjectTypes,
	getSelectedProjectTypes,
	getAppProps,
	getAriaText,
} from '../state/selectors.tsx';
import messages from './messages.tsx';
import ProjectTypeIcon from './project-type-icon/view.tsx';

export const projectTypeToDropdownOption = ({
	id,
	icon,
	name,
	isSelected,
}: {
	id: string;
	icon: string | undefined;
	name: string;
	isSelected: boolean;
}): ProjectTypeSelectOption => {
	const rebrandName = () => {
		switch (id) {
			case SERVICE_DESK_PROJECT:
				return messages.serviceDeskProject;
			case CORE_PROJECT:
				return messages.businessProjectSpork;
			case SOFTWARE_PROJECT:
				return messages.softwareProjectSpork;
			default:
				return messages.dynamicProjectNoTranslate;
		}
	};
	const message = rebrandName();

	return {
		value: id,
		isSelected,
		label: message.defaultMessage.replace('{name}', name), // label is been override by the content, providing label as it's required by the Select comoenent option
		content: (
			<DropdownItemContainer>
				{icon && <ProjectTypeIcon url={icon} />}
				<FormattedMessage {...message} values={{ name }} />
			</DropdownItemContainer>
		),
	};
};

export const getProjectTypes = createSelector(
	getStateProjectTypes,
	getSelectedProjectTypes,
	(projectTypes, selected) =>
		projectTypes.map(({ id, icon, name }) =>
			projectTypeToDropdownOption({
				id,
				icon,
				name,
				isSelected: selected.includes(id),
			}),
		),
);
getAppProps;
export const getAriaLabel = createSelector(getAriaText, (ariaLabelText) => ariaLabelText);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DropdownItemContainer = styled.div({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
});
